export const getAppState = (store) => store.app;
export const getAppVersion = (store) => (getAppState(store) ? getAppState(store).version : 'x.x.x');
export const getAppWidth = (store) => (getAppState(store) ? getAppState(store).width : 0);
